import React from 'react';

import { StyledProgressBar } from './styled';

export const PrimeProgressBar = () => {
  return <StyledProgressBar mode="indeterminate" />;
};
